module.exports = __webpack_public_path__ + "static/media/logo.44355b18.png";